import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import service from '../service';
import {
  Tab,
  Tabs,
  Typography,
  FormControlLabel,
  Button,
  Checkbox,
  TextField,
  FormGroup,
} from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';

import { useBoundStore } from '../../../../stores';
import { toast } from 'react-toastify';

function EditUserDrawer() {
  const { hash } = useLocation();
  const navigate = useNavigate();

  const [userFormData, setUserFormData] = useState({
    name: '',
    surname: '',
    phone: null,
  });

  const [valid, setValid] = useState(false);
  const toggleLeftDrawer = useBoundStore((state) => state.toggleLeftDrawer);

  const validateForm = () => {
    if (
      userFormData.name &&
      userFormData.surname
    ) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  const getUser = async () => {
    const response = await service.getUserById({
      userId: hash.split('#')[1]
    });
    const userData = response?.data;
    setUserFormData(() => ({
      ...userData,
      name: userData?.name || '',
      surname: userData?.surname || '',
      phone: userData?.phone || '',
    }));
  };

  const handleUpdate = async () => {
    // console.log(userFormData);
    await service.updateUser({
      userId: hash.split('#')[1],
      data: userFormData,
    }).then((response) => {
      if (response?.status === 200 || response?.status === 201) {
        toast.success('Kullanıcı başarıyla güncellendi.');
      } else {
        toast.error('Kullanıcı güncellenirken hata oluştu.');
      }
      navigate('/definitions/users');
      toggleLeftDrawer();
    });
  };

  useEffect(() => {
    getUser();
  }, [hash]);

  useEffect(() => {
    validateForm();
  }, [userFormData]);

  return (
    <div className="w-full flex flex-col justify-center items-center mt-5">
      <div className="w-full ">
        <div className="text-left px-2">
          <Typography variant="h6">Kullanıcı Güncelle</Typography>
        </div>
        <>
          <div className="flex flex-col">
            <div>
              <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full my-5 px-2">
                <TextField
                  label="Ad"
                  size="small"
                  fullWidth
                  variant="outlined"
                  value={userFormData.name}
                  onChange={(e) =>
                    setUserFormData({
                      ...userFormData,
                      name: e.target.value,
                    })
                  }
                />
                <TextField
                  label="Soyad"
                  size="small"
                  fullWidth
                  variant="outlined"
                  value={userFormData.surname}
                  onChange={(e) =>
                    setUserFormData({
                      ...userFormData,
                      surname: e.target.value,
                    })
                  }
                />
                <TextField
                  label="GSM"
                  size="small"
                  fullWidth
                  variant="outlined"
                  value={userFormData.phone}
                  onChange={(e) =>
                    setUserFormData({ ...userFormData, phone: e.target.value })
                  }
                />
                <Button
                  disabled={!valid || hash === ''}
                  variant="contained"
                  color="primary"
                  startIcon={<MATERIEL_ICONS.Save />}
                  onClick={() => handleUpdate()}
                  className="mx-2"
                >
                  Kaydet
                </Button>
              </div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
}

export default EditUserDrawer;
